// EducationComponent.jsx
import React, { useState } from "react";
import "remixicon/fonts/remixicon.css";
import CreatableSelect from "react-select/creatable";

function EducationComponent() {
  const [education, setEducation] = useState([]);
  const [course, setCourse] = useState([]);
  const [specialization, setSpecialization] = useState([]);
  const [courseType, setCourseType] = useState([]);

  // Sample data for Education Type
  const EducationList = [
    { value: "Undergraduate", label: "Undergraduate" },
    { value: "Postgraduate", label: "Postgraduate" },
    { value: "Doctorate", label: "Doctorate" },
    { value: "Diploma", label: "Diploma" },
    { value: "Certificate", label: "Certificate" },
    { value: "Vocational Training", label: "Vocational Training" },
    { value: "Professional Degree", label: "Professional Degree" },
    { value: "Associate Degree", label: "Associate Degree" },
    { value: "High School", label: "High School" },
    { value: "Technical Education", label: "Technical Education" },
    { value: "Adult Education", label: "Adult Education" },
    { value: "Online Education", label: "Online Education" },
    { value: "Continuing Education", label: "Continuing Education" },
    { value: "Community College", label: "Community College" },
    { value: "Military Education", label: "Military Education" },
    { value: "Special Education", label: "Special Education" },
    { value: "Alternative Education", label: "Alternative Education" },
    { value: "Primary Education", label: "Primary Education" },
    { value: "Secondary Education", label: "Secondary Education" },
    { value: "Higher Education", label: "Higher Education" },
    { value: "Medical Education", label: "Medical Education" },
    { value: "Legal Education", label: "Legal Education" },
    { value: "Business Education", label: "Business Education" },
    { value: "STEM Education", label: "STEM Education" },
    { value: "Humanities Education", label: "Humanities Education" },
    { value: "Teacher Education", label: "Teacher Education" },
    { value: "Arts Education", label: "Arts Education" },
  ];

  // Sample data for Course Type
  const CourseList = [
    { value: "Computer Science", label: "Computer Science" },
    { value: "Mechanical Engineering", label: "Mechanical Engineering" },
    { value: "Business Administration", label: "Business Administration" },
    { value: "Physics", label: "Physics" },
    { value: "English Literature", label: "English Literature" },
    { value: "Nursing", label: "Nursing" },
    { value: "Law", label: "Law" },
    { value: "Education", label: "Education" },
    { value: "Accounting", label: "Accounting" },
    { value: "Information Technology", label: "Information Technology" },
    { value: "Graphic Design", label: "Graphic Design" },
    { value: "Culinary Arts", label: "Culinary Arts" },
    { value: "Environmental Science", label: "Environmental Science" },
    { value: "Civil Engineering", label: "Civil Engineering" },
    { value: "Economics", label: "Economics" },
    { value: "Marketing", label: "Marketing" },
    { value: "Public Health", label: "Public Health" },
    {
      value: "Journalism and Mass Communication",
      label: "Journalism and Mass Communication",
    },
    { value: "Psychology", label: "Psychology" },
    { value: "Biomedical Engineering", label: "Biomedical Engineering" },
    { value: "Architecture", label: "Architecture" },
    { value: "Social Work", label: "Social Work" },
    { value: "Agricultural Science", label: "Agricultural Science" },
    { value: "Biotechnology", label: "Biotechnology" },
    { value: "Hospitality Management", label: "Hospitality Management" },
    { value: "Political Science", label: "Political Science" },
    { value: "Human Resources", label: "Human Resources" },
    { value: "Electrical Engineering", label: "Electrical Engineering" },
    { value: "Chemical Engineering", label: "Chemical Engineering" },
    { value: "Data Science", label: "Data Science" },
    { value: "Cybersecurity", label: "Cybersecurity" },
    { value: "Finance", label: "Finance" },
    { value: "Fine Arts", label: "Fine Arts" },
    { value: "Supply Chain Management", label: "Supply Chain Management" },
    { value: "Urban Planning", label: "Urban Planning" },
    { value: "Artificial Intelligence", label: "Artificial Intelligence" },
    { value: "Physical Therapy", label: "Physical Therapy" },
    { value: "Veterinary Science", label: "Veterinary Science" },
    { value: "Pharmacy", label: "Pharmacy" },
  ];

  const SpecializationList = [
    { value: "Artificial Intelligence", label: "Artificial Intelligence" },
    { value: "Data Science", label: "Data Science" },
    { value: "Machine Learning", label: "Machine Learning" },
    { value: "Cybersecurity", label: "Cybersecurity" },
    { value: "Network Security", label: "Network Security" },
    { value: "Human Resource Management", label: "Human Resource Management" },
    { value: "Finance Management", label: "Finance Management" },
    { value: "Marketing", label: "Marketing" },
    { value: "Operations Management", label: "Operations Management" },
    { value: "Organic Chemistry", label: "Organic Chemistry" },
    { value: "Quantum Physics", label: "Quantum Physics" },
    { value: "Biomedical Engineering", label: "Biomedical Engineering" },
    { value: "Pediatric Nursing", label: "Pediatric Nursing" },
    { value: "Corporate Law", label: "Corporate Law" },
    { value: "Constitutional Law", label: "Constitutional Law" },
    { value: "Educational Psychology", label: "Educational Psychology" },
    { value: "Tax Accounting", label: "Tax Accounting" },
    { value: "Forensic Accounting", label: "Forensic Accounting" },
    { value: "Software Engineering", label: "Software Engineering" },
    { value: "Web Development", label: "Web Development" },
    {
      value: "User Experience (UX) Design",
      label: "User Experience (UX) Design",
    },
    { value: "Graphic Design", label: "Graphic Design" },
    { value: "Pastry Arts", label: "Pastry Arts" },
  ];

  // Function to handle selection change
  const handleEducationChange = (selectedOptions) => {
    setEducation(selectedOptions || []);
  };

  // Function to handle selection change
  const handleCourseChange = (selectedOptions) => {
    setCourse(selectedOptions || []);
  };

  // Function to handle selection change
  const handleSpecializationChange = (selectedOptions) => {
    setSpecialization(selectedOptions || []);
  };

  return (
    <div className="mb-4">
      <h2 className="text-lg font-bold text-gray-900 mb-4">
        Education Details
      </h2>

      {/* Education Level */}
      <div className="mb-4 flex flex-col">
        <label className="mb-2 text-sm font-medium text-gray-700">
          Education
        </label>
        <CreatableSelect
          isMulti
          options={EducationList}
          value={education}
          onChange={handleEducationChange}
          placeholder="Select Education"
          className="mb-4"
        />
      </div>

      <div className="mb-4 flex flex-col">
        <label className="mb-2 text-sm font-medium text-gray-700">Course</label>
        <CreatableSelect
          isMulti
          options={CourseList}
          value={course}
          onChange={handleCourseChange}
          placeholder="Select Course"
          className="mb-4"
        />
      </div>

      <div className="mb-4 flex flex-col">
        <label className="mb-2 text-sm font-medium text-gray-700">
          Specialization
        </label>
        <CreatableSelect
          isMulti
          options={SpecializationList}
          value={specialization}
          onChange={handleSpecializationChange}
          placeholder="Select Specialization"
          className="mb-4"
        />
      </div>

      <div className="mb-4">
        <label className="mb-2 text-sm font-medium text-gray-700">
          Course Type
        </label>
        <div className="mt-1 text-gray-700">
          <label className="inline-flex items-center">
            <input
              type="radio"
              className="form-radio"
              value="Full-Time"
              checked={courseType === "Full-Time"}
              onChange={() => setCourseType("Full-Time")}
            />
            <span className="ml-2">Full-Time</span>
          </label>
          <label className="inline-flex items-center ml-24">
            <input
              type="radio"
              className="form-radio"
              value="Part-Time"
              checked={courseType === "Part-Time"}
              onChange={() => setCourseType("Part-Time")}
            />
            <span className="ml-2">Part-Time</span>
          </label>

          <label className="inline-flex items-center ml-24">
            <input
              type="radio"
              className="form-radio"
              value="Distance-Learning"
              checked={courseType === "Distance-Learning"}
              onChange={() => setCourseType("Distance-Learning")}
            />
            <span className="ml-2">Distance-Learning</span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default EducationComponent;
